import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemplateService} from '../../shared/services/template.service';
import {Router, Event, NavigationEnd} from '@angular/router';
import {AuthenticationService} from '../../authentication/authentication.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DataStorageService} from '../../shared/services/data-storage.service';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html'
})
export class SideNavComponent implements OnInit, OnDestroy {

    isCollapse: boolean;

    isSuperAdmin = false;
    isCarrier = false;   // ← 추가

    pending_counts: number;
    blocked_counts: number;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private tplSvc: TemplateService,
                private router: Router,
                private dataStorageService: DataStorageService,
                private authenticationService: AuthenticationService) {
        router.events
            .pipe(takeUntil(this.unsubscribe$)).subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                if (window.innerWidth < 992) {
                    this.tplSvc.toggleSideNavCollapse(false);
                }
            }
        });
        this.authenticationService.user
            .pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            if (user) {
                this.isSuperAdmin = +user.level === 1;
                this.isCarrier = +user.level === 4;   // ← 추가
            }
        });
        this.pending_counts = 0;
        this.blocked_counts = 0;
        this.dataStorageService.fetchPassengerNumsBlockedOrPending()
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            nums => {
                this.pending_counts = nums['pending'];
                this.blocked_counts = nums['blocked'];
            }
        );
    }

    ngOnInit() {
        this.tplSvc.isSideNavCollapseChanges
            .pipe(takeUntil(this.unsubscribe$)).subscribe(isCollapse => this.isCollapse = isCollapse);
    }

    // ← 추가
    goToCalendarOrPaxlist() {
        if (this.isCarrier) {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const currentMonth = `${yyyy}-${mm}`;
            this.router.navigate(['/pages/list-monthly-report', currentMonth, '1']);
        } else {
            this.router.navigate(['/apps/calendars']);
        }
    }

    toggleSideNavCollapse() {
        this.isCollapse = !this.isCollapse;
        this.tplSvc.toggleSideNavCollapse(this.isCollapse);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
